import React from 'react'
import PropTypes from 'prop-types'
import { by } from '../../utils'
import * as Styled from './ComparisonAttributes.styles'

const byFabricComposition = by.nameOf('fabric/composition')
const byCareInstructions = by.nameOf('care/instructions')
const splitByDoubleHash = item => item.value.split('##')
const generateListItems = items => items.map((item, key) => <li key={key}>{item}</li>)

const ComparisonAttributes = ({ attributes, type, parentId }) => {
  const { content } = (attributes && attributes[0]) || { content: [] }

  const materialItems = content
    .filter(byFabricComposition)
    .map(splitByDoubleHash)
    .reduce(by.aggregate.concat, [])

  const careItems = content
    .filter(byCareInstructions)
    .map(splitByDoubleHash)
    .reduce(by.aggregate.concat, [])

  return (
    <Styled.Container type={type} className='xs-12--none md-7--none xl-8--none'>
      {materialItems.length > 0 && <h4>Material</h4>}
      <Styled.List>{generateListItems(materialItems)}</Styled.List>
      {careItems.length > 0 && <h4>Care</h4>}
      <Styled.List>{generateListItems(careItems)}</Styled.List>
      {parentId ? (
        <p>
          <strong>Style number</strong>: {parentId.replace('.P', '')}
        </p>
      ) : null}
    </Styled.Container>
  )
}

ComparisonAttributes.propTypes = {
  /**
   * data to display
   */
  attributes: PropTypes.arrayOf(PropTypes.object).isRequired,
  /**
   * if desktop or mobile view
   */
  type: PropTypes.string
}

export default ComparisonAttributes
